export default __webpack_public_path__ + "static/securityplus-8a570e2d07c9f5836fcee672f13b1209.png";